<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title class="text-subtitle-1 grey lighten-2">
        {{ title }}
      </v-card-title>

      <v-card-text class="pt-3">
        <slot>
          処理を続行してもよろしいですか？
        </slot>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
          color="grey"
          text
          @click="dialog = false"
        >
          キャンセル
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :color="continueColor"
          @click="doAction"
        >
          {{ continueText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ContinueDialog', 
  props:{
    title: String,
    continueText: String,
    continueColor: String,
    executeAction: Function,
  },
  data: () => ({
    dialog: false,
  }),
  methods:{
    // ダイアログオープン（親コンポーネントから$refs経由で使用する）
    open() {
      this.dialog = true
    },
    doAction() {
      this.executeAction()
      this.dialog = false
    }
  },
}
</script>